import React from "react";

export default function TabsHeader({
  tabs,
  activeTab,
  setActiveTab,
  className = "",
}) {
  return (
    <div
      className={`flex w-full mb-6 flex-nowrap overflow-x-auto ${className}`}
    >
      {tabs.map((tab) => (
        <button
          key={tab.name}
          onClick={() => setActiveTab(tab.name)}
          className={`flex items-center whitespace-nowrap gap-2 py-4 px-5 border-b-2 rounded-tl-[10px] rounded-tr-[10px]  ${
            activeTab === tab.name
              ? "border-[#4285F4] text-[#4285F4] blueColorBtn"
              : "border-[#FAFAFA] text-[#B4B4B4] grayColorBtn"
          }`}
        >
          {tab.icon && <span className="">{tab.icon}</span>}
          <div className="text-span">{tab.name}</div>
        </button>
      ))}
    </div>
  );
}
